<app-topnav></app-topnav>
<div class="container px-0">
    <section>
        <div class="container-fluid mobile-px HomemainSliders">
            <div class="row">
                <div class="col-md-12">
                    <app-upcoming></app-upcoming>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <ul class="home-navigation-bar">
                        <li *ngFor="let item of menu;trackBy:trackByIndex;">
                            <a href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/sports', item?.id] : ['/guest/sports', item?.id]" *ngIf="item?.id != '99999' && item?.id != '99995'">
                                {{item?.name}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing03/slider1.jpg">
                </div>
            </div>
        </div>
    </section>
    <section class="text-center">
        <div class="container-fluid mobile-px">
            <div class="row">
                <div class="col-md-6">
                    <div class="sportDiv">
                        <a href="javascript:void(0)" [routerLink]="_common.getToken() ? ['/inplay'] : ['/guest/inplay']">
                            <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing03/banner-sport1.jpg">
                            <h2>sports</h2>
                        </a>

                        <div class="sportText">
                            <p class="live_icon"><span></span> LIVE</p>
                            <div *ngFor="let item of menu;trackBy:trackByIndex;">
                                <a href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/sports', item?.id] : ['/guest/sports', item?.id]" *ngIf="item?.id != '99999' && item?.id != '99995'">
                                    <h3>{{item?.name}}</h3>
                                    <span id="count">{{item?.data?.length}}</span>
                                </a>
                            </div>
                            <!-- <a href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/sports/1'] : ['/guest/sports/1']"><h3>football</h3><span id="count">6</span></a>
                            <a href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/sports/2'] : ['/guest/sports/2']"><h3>tennis</h3><span id="count">6</span></a> -->
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="sportDiv">
                        <a href="javascript:void(0);" [routerLink]="_common.getToken() ? ['/casino'] : ['/guest/casino']">
                            <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing03/livecasino.jpg">
                            <h2>indian casino</h2>
                        </a>
                    </div>
                </div>
            </div>
            <div class="sportDiv ic_section" (click)="redirectCasinoI()">
                <div class="row mx-lg-0">
                    <div class="col-md-3 col-6">
                        <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing03/inc5.jpg">
                    </div>
                    <div class="col-md-3 col-6">
                        <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing03/inc4.jpg">
                    </div>
                    <div class="col-md-3 col-6">
                        <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing03/inc3.jpg">
                    </div>
                    <div class="col-md-3 col-6">
                        <img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing03/inc2.jpg">
                    </div>
                    <h2>Live Casino</h2>
                </div>
            </div>
            <app-casino></app-casino>
            <!-- <div class="row">
                <div class="col-md-3">
                    <div class="sportDiv">
                        <img class="img-fluid" src="assets/img/casino/67630.png">
                        <h2>tennpatti test</h2>
                    </div>
                </div>
            </div> -->
        </div>
    </section>
    <div class="home-footer">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <img class="img-fluid hf-logo" src="/assets/img/{{env.host.name}}/logo.png" alt="">
                </div>
                <div class="col-md-4">
                    <h2>game therapy</h2>
                    <div class="gt">
                        <a><img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/18-plus.png"></a>
                        <a><img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/gt.png"></a>
                        <a><img class="img-fluid" src="https://speedcdn.io/assets/king-v8/icons/gamecare.png"></a>
                    </div>
                </div>
                <!-- <div class="col-md-3">
                    <h2>scan QR code</h2>
                    <img class="img-fluid scanecode" src="assets/img/{{env.host.name}}/scanecode.png">
                </div> -->
                <div class="col-md-4">
                    <h2>100% safe</h2>
                    <img class="img-fluid scanecode" src="https://speedcdn.io/assets/king-v8/icons/ssl.png">
                    <p>Protected connection and encrypted data.</p>
                </div>
                <div class="col-12 text-center">
                    <ul>
                        <li><a>about</a></li>
                        <li><a (click)="openPrivacyPolicyModal()">privacy</a></li>
                        <li><a (click)="openRuleModal()">rules</a></li>
                    </ul>
                </div>
                <div class="col-12">
                    <p class="home-copyright">© Copyright. All rights reserved</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" bsModal #rule="bs-modal" [config]="{backdrop: true}" tabindex="-1" role="dialog"
     aria-labelledby="dialog-static-name">
  <div class="modal-dialog pr-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title pull-left" id="">rules</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="ruleModal.hide()">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <div class="modal-body">
        <h3>GENERALRULES:</h3>
        <ul>
            <li>Incomplete session will be cancelled but completed session will be settled.</li>
            <li>In case of match abandoned, cancelled, no result etc. completed sessions will be settled.</li>
            <li>In case of a Tie match, only match odds will be cancelled , completed sessions will be continue.</li>
            <li>In Advance market only 1st inning valid.</li>

            <li>Total Match Four ,Total Match Sixes,Total Match Runs,Total Match Wides,Total Match Wicket.</li>
            <li>If Over Gets Less Then All BET Will Cancel This Rule For Limited Over Matches Like 20 Overs And 50 Overs Game.</li>

            <li>Batsman Runs (In-Play)(back/lay) runs bets will stand after batsman has faced one ball or is given out before first ball is faced.</li>
            <li>Score counts if batsman is Not-Out including if innings is declared. In case of rain, match abandoned etc. settled bets will be valid.</li>

            <li>Runs at Fall of 1st Wicket At least one delivery must be bowled, if no wickets fall bets will be void unless settlement is already determined.</li>

            <li>Lambi Paari : In 20-20 match entire twenty overs should be bowled, in case of rain or any delay if even one over is deducted the bets will be cancelled.
            <li>In One Day match entire 50 overs should be bowled, in case of rain or any delay if even one over is deducted the bets will be cancelled.</li>

            <li>1st Over Total Runs Prices will be offered for the total runs scored during the 1st over of the match.</li>
            <li>Extras and penalty runs will be included. The over must be completed for bets to stand unless settlement is already determined.</li>

            <li>Runs at Fall of Next Wicket The total innings runs scored by a team before the fall of the specified wicket determines the result of the market.</li>
            <li>If a team declares or reaches their target then the total amassed will be the result of the market.</li>
            <li>Bets will be void should no more play take place following the intervention of rain, or any other delay, as the ability to reach previous quotes offered will have been removed .</li>
            <li>In case of rain, match abandoned etc. settled bets will be valid.</li>

            <li>Khadda Fancy is Valid Only for First Innings of the Match In Case of Rain or If Over Gets Reduced then this Market Will get Void.</li>

            <li>In next men out fancy if player is injured particular fancy will be deleted.</li>

            <li>In fall of wicket one batsman is injured partnership is continued in next batsman. 14.If batsman faced one ball result will be valid.</li>
            <li>Current/Next Innings Runs Odd/Even Extras and Penalty runs will be included for settlement purposes.</li>

            <li>Total match wide result depends on how many wide come in match. Ex.if in wide ball there will be four run then its will count 5 wide on that ball.</li>
        </ul>

        <h3>TEST RULES:</h3>
        <ul>
            <li>In advance market only 1st inning valid.</li>

            <li>Completed session will be settled.</li>

            <li>If sessions not completed like england (80 over eng)session in case england declares or all out at 75 over session will be continue in australia inning.</li>

            <li>Due to weather situation match has been stopped all lambi trades will be void.</li>

            <li>Mandatory 70 over played in test lambi paari/ Innings run. If any team all-out or declaration lambi paari/ innings run is valid.</li>

            <li>Fall of wicket and batsman runs due to weather condition or match abandoned the result will be given as per score.</li>

            <li>If batsman faced one ball result will be valid.</li>

            <li>All bets of single over session will be deleted   in case session is incomplete. For example innings declared or match suspended to bad light or any other conditions.</li>

            <li>1st Day Total Run markets will only be valid if a minimum of 80 overs are bowled on this day. Otherwise all bets in this market will be void.</li>

            <li>1st day 1st session run minimum 25 over must be bowled otherwise 1st day 1st session will be void.
            1st day 2nd session run minimum 25 over must be bowled otherwise 1st day 2nd session will be void.</li>
        </ul>

        <h3>ODI RULES:</h3>

        <ul>
            <h3>SESSION:</h3>
            <li>In advance market only 1st inning valid. 2.Match 1st over run valid only in 1st inning.</li>
            <li>Completed session is valid in case weather condition or match abandoned runnning session will be deleted.</li>

            <li>Incomplete session will be cancelled but completed session will be settled.</li>

            <li>In One Day match entire 50 overs should be bowled in case of rain or any delay if even one over is deducted the bets will be cancelled.</li>

            <li>If batsman faced one ball result will be valid.</li>

            <li>Fall of wicket and batsman runs due to weather condition or match abandoned the result will be given as per score.</li>

            <li>Total match four ,total match sixes,total match runs,total match wides,total match wicket or all other fancy if over get less then all bet will be deleted.</li>
        </ul>
        <ul>
            <h3>T20 RULES:</h3>
            <li>In advance market only 1st inning valid. 2.Match 1st over run valid only in 1st inning.</li>
            <li>Completed session is valid in case weather condition or match abandoned runnning session will be deleted.</li>

            <li>Incomplete session will be cancelled but completed session will be settled.</li>

            <li>In T20 match entire 20 overs should be bowled in case of rain or any delay if even one over is deducted the bets will be cancelled.</li>

            <li>If batsman faced one ball result will be valid.</li>

            <li>Fall of wicket and batsman runs due to weather condition or match abandoned the result will be given as per score.</li>

            <li>Total match four ,total match sixes,total match runs,total match wides,total match wicket or all other fancy if over get less then all bet will be deleted.</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #privacyPolicy="bs-modal" [config]="{backdrop: true}" tabindex="-1" role="dialog"
     aria-labelledby="dialog-static-name">
  <div class="modal-dialog pr-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title pull-left" id="">Privacy and policy</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="privacyPolicyModal.hide()">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <div class="modal-body">
        <h3>title here</h3>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's</p>
        <p>standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make</p>
        <p>a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,</p>
         <p>remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing </p>
         <p>Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
      </div>
    </div>
  </div>
</div>

<app-loader class="no-overlay" *ngIf="isLoading"></app-loader>
<app-footer></app-footer>
